export default "__VITE_ASSET__CGhvz4BO__"